import React from "react";
import Button from "../Button";
import styles from './breakForm.module.css';

const BreakForm = ({ title, iconAction, actionVariant = "primary", handleAction, border = true, borderColor = "var(--surface-app)", showAction = true, compactAction = true }) => {
    return (
        <div className={`${styles.breakForm} ${border ? '' : styles.noBorder}`} style={{ borderColor }}>
            <div className={styles.action}>
                <span>{title}</span>
                {showAction &&
                    <Button variant={actionVariant} fullWidth={false} className={compactAction ? "action" : ""} onClick={handleAction}>{iconAction}</Button>
                }
            </div>
        </div>
    )
}

export default BreakForm
